/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
export const formatPercent = (field: any): number | string => {
  return field.toLocaleString('pt-BR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};
